import templateUrl from './alertsList.html';

export const alertsList = {
    bindings: {
        alerts: '<',
    },
    templateUrl,
    controller: [
        'alertingService',
        function (alertingService) {
            this.openIncidentModal = (alert) =>
                alertingService
                    .getCurrentPageNavigationContext()
                    .then((navigationContext) =>
                        alertingService.openIncidentModal(alert, navigationContext)
                    );
        },
    ],
};
